import { acme } from '@axo/shared/data-access/types';

export const acmeKeys = {
  root: ['acme'] as const,

  archiveSearch: (query: acme.ArchiveSearchReq) =>
    [...acmeKeys.root, 'archiveSearch', query] as const,
};
